import { useParams } from "react-router-dom";
import { MessagesLayout } from "../components/MessagesLayout";

/**
 * The DM thread route (/community/messages/:conversationId), reached from an inbox
 * row (or the friends "Message" action). It is the full-workspace two-pane
 * messaging surface with the route conversation OPEN:
 *   - DESKTOP — the conversation list (left, NOT unmounted) + the open thread
 *     (right pane), exposed as a labelled role="region" naming the counterpart.
 *   - MOBILE  — the thread REPLACES the list (single column) with a back
 *     affordance → /community/messages.
 *
 * Both the inbox and the thread routes are backed by the SAME `MessagesLayout`.
 * This route passes the `:conversationId` param as `activeId`, which drives the
 * message fetch, the once-per-open mark-read, the counterpart header (from the
 * inbox cache — cold deep-link → "Conversation", never the uuid), and the 1:1
 * "Seen" gate. The layout owns the surface's single <h1> above the workspace;
 * the thread pane is a region, NOT a second h1.
 */
export function ThreadPage() {
  const { conversationId } = useParams<{ conversationId: string }>();
  return <MessagesLayout activeId={conversationId} />;
}
